import axios from 'axios'
import { env } from './environment';

axios.interceptors.request.use(function (config) {
  config.headers['Request-Application'] = env.appHeader
  config.headers['Content-Type'] = 'application/json; charset=utf-8'
  config.headers['Accept'] = 'application/json; charset=utf-8'
  return config;
});